import { Drawer } from '@mantine/core';
import React from 'react';
import { drawerTransitionProps } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling.tsx';
import { BankAccountForm } from '@dealstack/frontend/shared/components/BankAccountForm/BankAccountForm.tsx';
import type {
	BankAccountDetails,
	BankAccountFormValues,
} from '@dealstack/frontend/shared/components/BankAccountForm/types.ts';
import type { BankAccountVerifyFn } from '@dealstack/frontend/shared/components/BankAccountForm/useBankAccountForm.types.ts';

interface Props {
	opened: boolean;
	onClose: () => void;
	title: string;
	hasPermission: boolean;
	bankAccount: BankAccountDetails | null;
	isRequestLoading: boolean;
	onSubmit: (formValues: BankAccountFormValues, bankAccountId?: string) => void;
	inferredCountryCode?: string;
	verifyIdentifiers?: BankAccountVerifyFn;
	headingTestId?: string;
}

export const BankAccountFormDrawer = ({
	opened,
	onClose,
	title,
	hasPermission,
	bankAccount,
	isRequestLoading,
	onSubmit,
	inferredCountryCode,
	verifyIdentifiers,
	headingTestId,
}: Props) => (
	<Drawer
		opened={opened}
		onClose={onClose}
		position="right"
		transitionProps={drawerTransitionProps}
		title={<span data-testid={headingTestId}>{title}</span>}
	>
		<BankAccountForm
			hasEditPermission={hasPermission}
			onSubmit={onSubmit}
			onCancel={onClose}
			isRequestLoading={isRequestLoading}
			bankAccount={bankAccount}
			inferredCountryCode={inferredCountryCode}
			verifyIdentifiers={verifyIdentifiers}
		/>
	</Drawer>
);
